
import broadcastsQuery from '~/graphql/queries/radio/broadcasts.gql';
import programQuery from '~/graphql/queries/radio/program.gql';
import carouselProgramsQuery from '~/graphql/queries/radio/carouselPrograms.gql';

export default {
  auth: false,
  apollo: {
    program: {
      query: programQuery,
      variables() {
        return {
          slug: this.$route?.params?.slug,
        };
      },
      update: data => data.program ?? {},
      result({data: {program}}) {
        if (!program) {
          return this.$nuxt.error({statusCode: 404, message: 'Pagina niet gevonden'});
        }
      },
    },
    programs: {
      query: carouselProgramsQuery,
      variables() {
        return {
          notSlug: this.$route?.params?.slug,
        };
      },
    },
    broadcasts: {
      query: broadcastsQuery,
      variables() {
        return {
          programSlug: this.$route?.params?.slug,
        };
      },
    },
  },
  data: vm => ({
    internalBroadcastsPageCounter: 1,
    broadcasts: [],
    program: {},
    programs: [],
  }),
  methods: {
    isBroadcastActivatable(broadcast) {
      return this.$dateFns.isPast(this.$dateFns.parseISO(broadcast.date));
    },
    handleFetchMoreBroadcasts(program) {
      this.$apollo.queries.broadcasts.fetchMore({
        variables: {
          page: ++this.internalBroadcastsPageCounter,
        },
        updateQuery: (previousResult, {fetchMoreResult}) => ({
          broadcasts: {
            ...fetchMoreResult.broadcasts,
            data: [...previousResult.broadcasts.data, ...fetchMoreResult.broadcasts.data],
          },
        }),
      });
      this.$gtag('event', 'radio_history', {program: program.title});
    },
  },
};
